var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaseGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 83 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    x1: 10,
    y1: 10,
    x2: 10,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    x1: 22.5,
    y1: 10,
    x2: 22.5,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    x1: 35,
    y1: 10,
    x2: 35,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    x1: 47.5,
    y1: 10,
    x2: 47.5,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    x1: 60,
    y1: 10,
    x2: 60,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    x1: 72.5,
    y1: 10,
    x2: 72.5,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    x1: 9.5,
    y1: 10,
    x2: 73,
    y2: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    x1: 10,
    y1: 30,
    x2: 72.5,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    x1: 10,
    y1: 50,
    x2: 72.5,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    x1: 10,
    y1: 70,
    x2: 72.5,
    y2: 70
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    x1: 10,
    y1: 90,
    x2: 72.5,
    y2: 90
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseGrid);
export default __webpack_public_path__ + "static/media/BaseGrid.e0471a0b4fcc8d51b5895c4c15cf3596.svg";
export { ForwardRef as ReactComponent };